module.exports = __webpack_public_path__ + "img/i_x_n_dark_green.577196e8.svg";